import * as React from "react";
import { connect } from "react-redux";
import * as selectors from "../selectors";
import { RootState } from "src/ipm-shared/store/model/reducers";
import { ControlErrorType } from "../types";

type IHasFieldErrorProps = {
  form: string;
  children: (
    errors: ControlErrorType[],
    displayError?: boolean
  ) => React.ReactNode;
  name: string;
};
const mapStateToProps = (
  state: RootState,
  props: IHasFieldErrorProps
): {
  displayError?: boolean;
  errors: ControlErrorType[];
} => ({
  displayError: selectors.getControl(state, props.name, props.form)
    .displayError,
  errors: selectors.getControl(state, props.name, props.form).errors
});

type IProps = ReturnType<typeof mapStateToProps> & IHasFieldErrorProps;

/**
 * This is one of common controls in the entire app.
 * Use this when you want to show Form errors.
 */
class IHasFieldError extends React.Component<IProps, any> {
  public render() {
    return this.props.children(this.props.errors, this.props.displayError);
  }
}

export default connect(mapStateToProps)(IHasFieldError);
